import { type PostNordDeliveryType } from 'ecosystem'

// @see https://www.postnord.se/en/business/prices-and-terms-for-businesses/special-terms-and-conditions-for-service-agreement-customers/
export const postnordDeliveryOptionsLimits: Partial<
  Record<PostNordDeliveryType, { maxWeight?: number }>
> = {
  mailbox: {
    maxWeight: 2
  },
  'express-mailbox': {
    maxWeight: 2
  },
  'home-small': {
    maxWeight: 3
  },
  'service-point': {
    maxWeight: 20
  },
  'parcel-locker': {
    maxWeight: 20
  }
}
